app.directive("checkoutCartForm", [
  '$http'
  '$timeout'
  '$compile'
  'checkoutService'
  'cartService'
  'mainConfig'
  '$rootScope'
  'logger'
  (
    $http
    $timeout
    $compile
    checkoutService
    cartService
    mainConfig
    $rootScope
    logger
  ) ->
    {
      restrict: 'A'
      link: (scope, element, attrs) ->
        onCartFormLoaded = (() -> scope.$emit("checkout.cart.form.loaded"))
        
        scope.zeekPickupStatus = {}

        scope.$on "checkout.cart.form.reload", () ->
          checkoutService.requestPartial('cart', 'form')
            .then (res) ->
              scope.$broadcast("checkout.cart.form.rerender")
              $timeout((() -> element.html($compile(res.data)(scope))), 0)
            .catch (error) ->
              logger.error("Unable to load cart form")
            .finally (() -> onCartFormLoaded())

        element.on "change", "#order-delivery-country", (event) ->
          $rootScope.$emit('cart.form.country.change')
          updateOption { country: angular.element(event.currentTarget).val() }

        element.on "change", "#order-delivery-method", (event) ->
          $rootScope.$emit('cart.form.delivery.change')
          updateOption { delivery_option_id: angular.element(event.currentTarget).val(), delivery_data: {}}

        element.on "change", "#order-payment-method", (event) ->
          updateOption { payment_id: angular.element(event.currentTarget).val() }

        scope.onSfLocationChange = (deliveryData) ->
          updateOption { delivery_data: (deliveryData || {}) }, { rerender: false }

        scope.onPakpoboxLocationChange = (deliveryData) ->
          updateOption { delivery_data: (deliveryData || {}) }, { rerender: false }

        scope.onZeekLocationChange = (deliveryData) ->
          updateOption { delivery_data: (deliveryData || {}) }, { rerender: false }

        updateOption = (data, options) ->
          options = {} if !options?
          _.defaults(options, { rerender: true })

          scope.$emit "checkout.cart.form.changing" if options.rerender
          checkoutService.requestPartial('cart', 'form', data)
            .then (res) ->
              if options.rerender
                scope.$broadcast("checkout.cart.form.rerender")
                $timeout((() -> element.html($compile(res.data)(scope))), 0)
              scope.$emit "checkout.cart.form.changed", { rerender: options.rerender }
            .catch (error) ->
              logger.error "Unable to update option"
              logger.error data
            .finally (() -> onCartFormLoaded())

        element.on "destroy", (() -> element.off()) # Unbind events
    }
])
